import { type CSSObject } from '@emotion/react';
import { useTheme } from '@doxyme/ui/theme';
import { useViewport } from '@doxyme/ui/hooks';
import { type UpsellCardProps } from './upsellCard';

type UseStylesReturnType = Record<
  | 'wrapperCSS'
  | 'cardCSS'
  | 'imageWrapperCSS'
  | 'contentCSS'
  | 'contentItemCSS'
  | 'iconWrapperCSS'
  | 'titleCSS'
  | 'descriptionCSS'
  | 'buttonCSS',
  CSSObject
>;

export const useUpsellCardStyles = (
  imageSize?: UpsellCardProps['imageSize'],
): UseStylesReturnType => {
  const theme = useTheme();
  const { isSmallViewport } = useViewport();

  return {
    wrapperCSS: {
      width: '100%',
      columnGap: theme.spacing(6),
    },
    cardCSS: {
      display: 'flex',
      columnGap: theme.spacing(4),
      rowGap: theme.spacing(6),
      justifyContent: 'center',
      alignItems: isSmallViewport ? 'center' : 'stretch',
      flexDirection: isSmallViewport ? 'column' : 'row',
      padding: isSmallViewport ? theme.spacing(6) : theme.spacing(8, 6, 8, 0),
      border: `1px solid ${theme.subscription.proFeatureContainer.border}`,
      borderRadius: theme.shape.radius8,
      background: theme.subscription.proFeatureContainer.background,
    },
    imageWrapperCSS: {
      flexShrink: 0,
      height: 'auto',
      width: isSmallViewport ? '165px' : '40%',
      '& > svg': {
        height: imageSize ?? '100%',
        width: imageSize ?? '100%',
      },
    },
    contentCSS: {
      flexDirection: 'column',
      rowGap: theme.spacing(6),
    },
    contentItemCSS: {
      alignItems: 'flex-start',
      columnGap: theme.spacing(3),
    },
    iconWrapperCSS: {
      flexShrink: 0,
      color: theme.icon.upgrade,
    },
    titleCSS: {
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.text.generic.primary,
    },
    descriptionCSS: {
      color: theme.text.generic.secondary,
    },
    buttonCSS: {
      flex: 'initial',
      minWidth: 'auto',
    },
  };
};
